class SiteAlert {
	constructor(el) {
		this._handleCloseClick = this._handleCloseClick.bind(this)

		if (!el) {
			throw Error(`Site Alert did not receive an element.`)
		}
		if (!el.id) {
			throw Error(`Site Alert must have a unique id.`)
		}
		this.el = el
		const closeButton = this.el.querySelector('[data-role="js--dismiss"]')
		closeButton && closeButton.addEventListener('click', this._handleCloseClick)
	}
	_handleCloseClick(event) {
		this.el.dispatchEvent(new CustomEvent('alert-dismissed'))
		this._hide()
		event.preventDefault()
	}
	_hide() {
		const height = this.el.offsetHeight

		requestAnimationFrame(() => {
			this.el.style.marginTop = `-${height}px`

			requestAnimationFrame(() => {
				this.el.classList.remove('in')

				setTimeout(() => {
					this.el.classList.add('d-none')
				}, 500)
			})
		})

	}
}

export default SiteAlert
